<h2 mat-dialog-title>Escolha seu tipo de conta</h2>

<mat-action-list>
  <button mat-list-item (click)="click('CANDIDATE')" class="actived">
    <h3 matLine>Conta de candidato</h3>
    <p matLine>
      Receba proposta de vagas e candidate-se para entrevista e acompanhe o
      processo de seleçao
    </p>
    <span matLine>Clique para escolher</span>
  </button>

  <button mat-list-item (click)="click('RECRUITER')">
    <h3 matLine>Conta de recrutador</h3>
    <p matLine>
      Pesquise candidatos, crie e gerencie processos seletivos, marque
      entrevistas e escolha os candidatos certos para sua vaga
    </p>
    <span matLine>Clique para escolher</span>
  </button>
</mat-action-list>

<mat-dialog-content> </mat-dialog-content>
<mat-dialog-actions>
  <button color="accent" mat-button mat-dialog-close>Cancelar</button>
  <!--<button color="primary" mat-raised-button (click)="close()" [disabled]="!selectType">Continuar</button>-->
</mat-dialog-actions>
